import {
    parseBullionChallengeEntityRef,
    parseSquaresChallengeEntityRef,
} from "../components/notifications/notificationDisplay";
import { ENTRY_POINT_CHALLENGE, persistGameEntryPoint } from "./frontendTrackingEvents";

const CHALLENGE_NOTIFICATION_TYPES = new Set([
    "squares_match_challenge",
    "squares_match_challenge_sent",
    "bullion_match_challenge",
    "bullion_match_challenge_sent",
]);

/** Persist `entry_point: challenge` when user enters a game from a challenge notification. */
export function persistChallengeGameEntryFromNotification(notification: {
    type?: string;
    entity_ref?: string | null;
}): void {
    const type = notification?.type;
    if (!type || !CHALLENGE_NOTIFICATION_TYPES.has(type)) return;

    if (type.startsWith("squares_")) {
        const { matchId } = parseSquaresChallengeEntityRef(notification.entity_ref ?? null);
        if (!matchId) return;
        persistGameEntryPoint({
            entry_point: ENTRY_POINT_CHALLENGE,
            fixture_id: matchId,
            game_type: "squares",
        });
        return;
    }

    if (type.startsWith("bullion_")) {
        const { matchId } = parseBullionChallengeEntityRef(notification.entity_ref ?? null);
        if (!matchId) return;
        persistGameEntryPoint({
            entry_point: ENTRY_POINT_CHALLENGE,
            fixture_id: matchId,
            game_type: "bullion",
        });
    }
}
